import {useCallback, useMemo, useState} from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button } from '@/components/common/Button'
import ExternalLink from '@/components/common/ExternalLink'
import { hasOnboarded, useCurrentUser } from '@/hooks/useCurrentUser'
import { HUB_DOWNLOAD_URL } from '@/config/settings'
import logoSvg from '/static/img/logo.svg?no-inline'

const Welcome = () => {
  const navigate = useNavigate()
  const { refetch, isFetching, data: user } = useCurrentUser()
  const [notReady, setNotReady] = useState(false)

  // The username is assigned by Hub, so re-read the profile before moving on.
  // Navigating blindly would just bounce the user straight back here via the
  // guard in the _auth layout with no explanation.
  const handleContinue = useCallback(async () => {
    const { data } = await refetch()
    if (hasOnboarded(data)) {
      void navigate({ to: '/shardlibrary', replace: true })
      return
    }
    setNotReady(true)
  }, [navigate, refetch])

  const isNew = useMemo(() => {
    return true
    // if (!user?.date_joined) {
    //   return false
    // }
    // // return true if within the last day
    // const joinedAt = new Date(user.date_joined).getTime()
    // return !Number.isNaN(joinedAt) && Date.now() - joinedAt < 24 * 60 * 60 * 1000
  }, [user])

  return (
    <section className="h-full w-full flex flex-col items-center justify-center overflow-y-auto bg-[var(--ggBackground)] text-[#B9C4D7] p-8">
      <div className="flex flex-col max-w-screen-md gap-6 items-center justify-center justify-items-center text-center">
        <img
          src={logoSvg}
          alt="GameGlass"
          width={100}
          height={100}
          className="flex w-[100px] mb-6"
        />

        <h1 className="m-0 p-0 text-3xl font-semibold leading-tight text-white">
          { isNew ? "Thanks for signing up to GameGlass" : "Welcome to GameGlass" }
        </h1>

        {isNew && (<>
        <p>
          <strong>Enjoy 14 days of PRO for free, starting now!</strong><br/>
          We’ve unlocked all premium features for you so you can experience everything GameGlass has to offer.<br/>
          Jump in and see what you can do.
        </p>
        </>)}


        <p className="text-lg leading-snug">
          To finish setting up your account you need GameGlass Hub running on your PC.<br/>
          <ExternalLink href={HUB_DOWNLOAD_URL} useDefaultBrowser style={{color: "white"}}>Download it at {HUB_DOWNLOAD_URL.replace('https://', '')}</ExternalLink>, then install and sign in with the same account.
        </p>

        {notReady && (
          <p className="text-base leading-snug text-[var(--ggErrorColor)]" role="status">
            We could not find your Hub account yet. Make sure Hub is installed, signed in and you've chosen your username, then try again.
          </p>
        )}

        <Button {...(isFetching ? {outline: true} : {primary: true})} onClick={handleContinue} disabled={isFetching} wrap={false}>
          {isFetching ? 'Checking...' : "I've installed GameGlass Hub"}
        </Button>
      </div>
    </section>
  )
}

export const Route = createFileRoute('/_auth/welcome')({
  component: Welcome,
})
